// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.omprIASpalwGl75C0ekV{border:1px solid var(--border-neutral-default);cursor:pointer;border-radius:6px;align-items:center;width:100%;height:44px;display:flex}.C4n8rf100Hg2o0nrfZqM{border-color:var(--border-brand-default);background:var(--light-blue-10)}.KYW8lDCld6c04AI1PMS2{margin:0 12px}.nQbK0eVum4u5JPwji71s{flex:1;min-width:0;margin-left:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `omprIASpalwGl75C0ekV`,
	"rowSelected": `C4n8rf100Hg2o0nrfZqM`,
	"checkbox": `KYW8lDCld6c04AI1PMS2`,
	"label": `nQbK0eVum4u5JPwji71s`
};
export default ___CSS_LOADER_EXPORT___;
